

(window => {
    if (!document.body.matches('.single-post')) return;

    // JS Utility based on https://codepen.io/callumbw95/pen/mdPXMag
    // upgraded to match our formatting
    window.media = {};
    
    const responsiveHandler = (handler) => (e) => e.matches && handler();
    
    const responsive = (device, handler, init = true) => {
        if (init && window.media[device].matches) handler();
        if (window.media[device]) media[device].addListener(responsiveHandler(handler));
    };
    
    const createBreakpoint = (device, min = null, max = null) =>
        (window.media[device] = window.matchMedia(`
            ${min ? `(min-width: ${min}px)` : ""}
            ${min && max ? " and " : ""}
            ${max ? `(max-width: ${max}px)` : ""}
        `));
    
    // Config
    createBreakpoint("mobile", null, 1079);
    createBreakpoint("desktop", 1080, null);
    
    // post newsletter
    const movePostNewsletter = (to) => () => {
        const postNewsletter = document.querySelector('[data-target="post-newsletter"]');
        
        if (!postNewsletter) return;

        const anchors = [...document.querySelectorAll('[data-target="post-newsletter-anchor"]')];
        const targetAnchor = anchors.filter(el => el.dataset.device === to)[0];

        if (!targetAnchor) return;
        
        targetAnchor.appendChild(postNewsletter);
    }
    
    responsive("mobile", movePostNewsletter("mobile"));
    responsive("desktop", movePostNewsletter("desktop"));

    return window;
})(window)
